export const FETCH_LAYERS_REQUEST = 'FETCH_LAYERS_REQUEST';
export const FETCH_LAYERS_FAILURE = 'FETCH_LAYERS_FAILURE';
export const FETCH_LAYERS_SUCCESS = 'FETCH_LAYERS_SUCCESS';

export const FETCH_LAYER_REQUEST = 'FETCH_LAYER_REQUEST';
export const FETCH_LAYER_FAILURE = 'FETCH_LAYER_FAILURE';
export const FETCH_LAYER_SUCCESS = 'FETCH_LAYER_SUCCESS';

export const SET_BASE_LAYER = 'SET_BASE_LAYER';
export const SET_LAYER_SELECTED_LAYER_FROM_SEARCH = 'SET_LAYER_SELECTED_LAYER_FROM_SEARCH';